export default function TripUtils(
    $window,
    localStorageService,
    basketService,
    userService,
    flightsUtils
) {
    'ngInject';

            const CARD_VERIFICATION_URLS_PREFIX = 'verificationUrls_';

            /**
             * ------------- Private methods ------------------------------------------------------------------
             */

            function prepareFlightsData() {
                const flightsData = [];
                const flightsFromBasket = basketService.getFlights();

                if (!flightsFromBasket.length) {
                    return flightsData;
                }

                angular.forEach(flightsFromBasket, function(flight) {
                    flightsData.push({
                        SearchId: flight.searchId,
                        RecommendationId: flight.recommendationId,
                        FareRecommendationGuid: flight.fareRecommendationId,
                        SearchFlightGroupIds: flight.groupIds,
                        IsRoundtrip: flight.isRoundtrip,
                    });
                });

                return flightsData;
            }

            function prepareHotelsData() {
                const hotelsData = [];
                const hotelsFromBasket = basketService.getHotels();

                if (!hotelsFromBasket.length) {
                    return hotelsData;
                }

                angular.forEach(hotelsFromBasket, function(hotel) {
                    hotelsData.push({
                        SearchId: hotel.searchId,
                        SearchHotelId: hotel.hotelId,
                        RoomId: hotel.roomId,
                    });
                });

                return hotelsData;
            }

            function prepareCarsData() {
                const carsData = [];
                const carsFromBasket = basketService.getCars();

                if (!carsFromBasket.length) {
                    return carsData;
                }

                angular.forEach(carsFromBasket, function(car) {
                    carsData.push({
                        CarFareId: car.carFareId,
                        SearchId: car.searchId,
                        SearchCarId: car.carId,
                    });
                });

                return carsData;
            }

            function prepareRailsData() {
                const railsData = [];
                const railsFromBasket = basketService.getRails();

                if (!railsFromBasket.length) {
                    return railsData;
                }

                angular.forEach(railsFromBasket, function(rail) {
                    railsData.push({
                        SearchId: rail.searchId,
                        OutwardJourneyId: rail.outwardJourneyId,
                        OutwardTicketId: rail.outwardJourneyTicketId,
                        ReturnJourneyId: rail.ReturnJourneyId,
                        ReturnTicketId: rail.ReturnJourneyTicketId,
                        ReturnOrSingle: rail.ReturnOrSingle,
                        AddOns: rail.AddOns,
                        TicketDeliveryOptionType: rail.TicketDeliveryOptionType,
                        DeliveryDetails: rail.DeliveryDetails,
                        OutSeatPreference: rail.OutSeatPreference,
                        ReturnSeatPreference: rail.ReturnSeatPreference,
                        TicketDeliveryOptionFee: rail.TicketDeliveryOptionFee,
                        OutOfPolicyStatus: rail.OutOfPolicyStatus,
                    });
                });

                return railsData;
            }

            function prepareEuRailsData() {
                const euRailsData = [];
                const euRailsFromBasket = basketService.getEuRails();

                if (!euRailsFromBasket.length) {
                    return euRailsData;
                }

                angular.forEach(euRailsFromBasket, function(rail) {
                    let returnJourney = null;
                    if (rail.returnJourney) {
                        returnJourney = {
                            JourneyId: rail.returnJourney.Id,
                            AlternativeIds: rail.returnAlternative.Ids,
                            TravelClass: rail.journeys[1].travelClass,
                            Legs: rail.returnJourney.Legs,
                            Fares: rail.returnAlternative.Fares,
                            SupplierPrice: rail.returnAlternative.SupplierPrice,
                            SupplierCurrency: rail.returnAlternative.SupplierCurrency,
                        };
                    }
                    euRailsData.push({
                        OutwardJourney: {
                            JourneyId: rail.outwardJourney.Id,
                            AlternativeIds: rail.outwardAlternative.Ids,
                            TravelClass: rail.journeys[0].travelClass,
                            Legs: rail.outwardJourney.Legs,
                            Fares: rail.outwardAlternative.Fares,
                            SupplierPrice: rail.outwardAlternative.SupplierPrice,
                            SupplierCurrency: rail.outwardAlternative.SupplierCurrency,
                        },
                        ReturnJourney: returnJourney,
                        Adults: rail.seats,
                        SearchId: rail.searchId,
                    });
                });

                return euRailsData;
            }

            /**
             * ------------- Public methods ------------------------------------------------------------------
             */

            return {
                openCardValidationUrls: function(tripId) {
                    // We assume that could be only one TF flight in a trip
                    const urls = localStorageService.get(CARD_VERIFICATION_URLS_PREFIX + tripId);

                    if (!urls || !urls.length) {
                        return false;
                    }

                    const url = urls.shift();
                    localStorageService.set(CARD_VERIFICATION_URLS_PREFIX + tripId, urls);

                    if (url) {
                        $window.location.href = url;
                        return true;
                    }
                },

                setCardValidationUrls: function(tripDetails, cardValidationUrls) {
                    localStorageService.set(CARD_VERIFICATION_URLS_PREFIX + tripDetails.Id, cardValidationUrls);
                },

                collectTripData: function(params) {
                    const tripData = {};
                    const flightsData = prepareFlightsData();
                    const hotelsData = prepareHotelsData();
                    const carsData = prepareCarsData();
                    const railsData = prepareRailsData();
                    const euRailsData = prepareEuRailsData();

                    tripData.FlightRecommendations = flightsData;
                    tripData.Hotels = hotelsData;
                    tripData.Cars = carsData;
                    tripData.Rails = railsData;
                    tripData.EuRails = euRailsData;

                    if (params) {
                        Object.assign(tripData, params);
                    }

                    return tripData;
                },

                getFlights: function(tripDetail) {
                    return (tripDetail) ? tripDetail.Flights : basketService.getFlights();
                },

                getHotels: function(tripDetail) {
                    return (tripDetail) ? tripDetail.Hotels : basketService.getHotels();
                },

                getCars: function(tripDetail) {
                    return (tripDetail) ? tripDetail.Cars : basketService.getCars();
                },

                getRails: function(tripDetail) {
                    return (tripDetail) ? tripDetail.Rails : basketService.getRails();
                },

                getTripDestination: function(tripDetails) { // eslint-disable-line
                    if (!tripDetails) {
                        return null;
                    }

                    const {Flights, Hotels, Cars, Rails} = tripDetails;

                    if (Flights && Flights.length) {
                        const route = flightsUtils.getRoute(tripDetails.Flights[0], '/');
                        if (route) {
                            const routeList = route.split('/');
                            if (routeList.length > 1) {
                                return routeList[1];
                            }
                        }
                    }
                    if (Hotels && Hotels.length) {
                        return Hotels[0].City;
                    }
                    if (Cars && Cars.length) {
                        return Cars[0].PickUpCity;
                    }
                    if (Rails && Rails.length) {
                        return Rails[0].ArrivalStation;
                    }
                    return null;
                },

                generateRulesParameters: function(flight, travellers) {
                    return {
                        fare: flight.FareRecommendationId,
                        recommendation: flight.SearchFlightRecommendationId,
                        search: flight.SearchCacheId,
                        adult: (travellers.Adult)
                            ? travellers.Adult.length
                            : _.where(travellers, {PassengerType: 'Adult'}).length,
                        child: (travellers.Child)
                            ? travellers.Child.length
                            : _.where(travellers, {PassengerType: 'Child'}).length,
                        infant: (travellers.Infant)
                            ? travellers.Infant.length
                            : _.where(travellers, {PassengerType: 'Infant'}).length,
                        groups: _.map(flight.FlightGroups, 'GroupId'),
                        culture: userService.getCulture(),
                    };
                },

                countDays: function(checkIn, checkOut) {
                    const START_OF_DAY = 'day';
                    const DIFF_DAYS = 'days';
                    const co = moment(checkOut).startOf(START_OF_DAY);
                    const ci = moment(checkIn).startOf(START_OF_DAY);
                    return co.diff(ci, DIFF_DAYS);
                },

                collectAllDestinationsDataForFlight,
                getFlightGroupTime,
                isTripRefundable,
                getTripNonRefundableItems,
                getRailMessageFlags,
            };

            function collectAllDestinationsDataForFlight(flightGroups) {
                let destinations = [];
                _.forEach(flightGroups, function(group) {
                    destinations = destinations.concat(getFlightGroupDestinations(group));
                });
                return destinations;
            }

            function getFlightGroupDestinations(group) {
                const groupDestinations = [];
                const stops = _.pluck(group.FlightStops, 'City');
                _.forEach(group.Flights, function(flight) {
                    if (!_.contains(stops, flight.DepartureAirportCity)) {
                        groupDestinations.push({
                            airport: flight.DepartureAirport,
                            airportCity: flight.DepartureAirportCity,
                            airportCode: flight.DepartureAirportCode,
                            countryCode: flight.DepartureCountryCode,
                            departureDate: flight.DepartureDate,
                        });
                    }
                    if (!_.contains(stops, flight.ArrivalAirportCity)) {
                        groupDestinations.push({
                            airport: flight.ArrivalAirport,
                            airportCity: flight.ArrivalAirportCity,
                            airportCode: flight.ArrivalAirportCode,
                            arrivalDate: flight.ArrivalDate,
                        });
                    }
                });
                return groupDestinations;
            }

            function getFlightGroupTime(flightGroup) {
                const destinations = getFlightGroupDestinations(flightGroup);
                return _.reduce(destinations,
                    (times, destination) => {
                        times.push(destination.departureDate || destination.arrivalDate);
                        return times;
                    }, []);
            }

            function isTripRefundable(tripDetails) {
                return (tripDetails.Status === 'Quote' || tripDetails.Status === 'Held')
                        || !_.find(tripDetails.Hotels, {Refundable: false});
            }

            function getTripNonRefundableItems(tripDetails) {
                return _.chain(tripDetails.Hotels)
                    .filter({Refundable: false})
                    .map((hotel) => {
                        return {name: hotel.Name};
                    })
                    .value();
            }

            function getRailMessageFlags(tripDetails) {
                if (!tripDetails.IsRailTripItemExist) {
                    return {
                        isPartiallyRefundable: false,
                        isFullyRefundable: false,
                        isNonrefundable: false,
                    };
                }

                const prices = tripDetails.Prices;

                const isFullyRefundable
                    = tripDetails.Rails.every((rail) => rail.CanBeRefunded)
                    && prices.RailRefundablePrice.Amount === prices.RailTotalPrice.Amount - prices.CreditCardFee.Amount;

                const isPartiallyRefundable
                    = !isFullyRefundable
                        && tripDetails.Rails.some((rail) => rail.CanBeRefunded)
                        && prices.RailRefundablePrice.Amount !== 0
                        && prices.RailRefundablePrice.Amount < prices.RailTotalPrice.Amount - prices.CreditCardFee.Amount;

                const isNonrefundable = !isPartiallyRefundable && !isFullyRefundable;

                return {
                    isPartiallyRefundable,
                    isFullyRefundable,
                    isNonrefundable,
                };
            }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/services/tripUtils.js